import { Component, EventEmitter, Inject, LOCALE_ID, OnInit, Output } from '@angular/core';
import { formatDate } from '@angular/common';
import { FirestoreService } from '../../_services/firestore.service';
import firebase from 'firebase/compat/app';
import { ROLE_ADMIN, ROLE_MANAGER, ROLE_USER } from '../../_utils/constants/const';
import { ComponentBase } from '../../_utils/component.base';
import { ModalController } from '@ionic/angular';
import { SettingsService } from '../../_services/settings.service';
import { UserService } from '../../_services/user.service';

@Component({
  selector: 'app-chat-modal',
  templateUrl: './chat-modal.component.html',
  styleUrls: ['./chat-modal.component.scss'],
})

export class ChatModalComponent extends ComponentBase implements OnInit {

  @Output() showNewChatNotif: EventEmitter<boolean> = new EventEmitter<boolean>();

  loggedUser: {
    role: string,
    displayName: string,
    id: string
  } = {
    role: '',
    displayName: '',
    id: ''
  };

  assignedTutorId: string;
  assignedTutorName: string;
  hasMessages: boolean = false;
  noUserYet: boolean = false;
  _showNewChatNotif: boolean = false;
  userList: any[];

  messages: any[]; // Replace with actual message model
  newMessage: string = '';

  currentChatId: string;
  friendUser: any; // Replace with actual user model

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private firestoreService: FirestoreService,
    private modalCtrl: ModalController,
    private settingsService: SettingsService,
    private userService: UserService,
  ) {
    super();
  }

  async ngOnInit() {
    this.getUserData();
  }

  private getTutor = async (): Promise<void> => {
    const [tutor] = await this.settingsService.getCompanyTutors();
    if (!tutor) {
      return;
    }
    const user = await this.userService.getUser(tutor);
    this.assignedTutorId = user.uid;
    this.assignedTutorName = user.firstName;
  };

  closeModal() {
    const dataToReturn = {showNewChatNotif: this._showNewChatNotif};
    this.modalCtrl.dismiss(dataToReturn);
  }

  toggleView() {
    this.currentChatId = null;
    //this.firestoreService.markAsRead(this.friendUser.id, this.loggedUser.id);
    this._showNewChatNotif = false;
  }

  async getUserData() {
    await this.storage.get('user').then(dataUser => {
      if (dataUser) {
        dataUser.role ? this.loggedUser.role = dataUser.role : this.loggedUser.role = ROLE_USER;
        this.loggedUser.id = dataUser.uid;
        this.loggedUser.displayName = `${dataUser.firstName} ${dataUser.lastName}`;
      }
    });
    await this.getTutor();
    this.loadFriendsList();
  }

  loadFriendsList() {
    this.firestoreService.getFriendsList(this.loggedUser.id).subscribe(users => {
      if (this.loggedUser.role === ROLE_ADMIN) {
        if (users.length > 0) {
          this.userList = users;
          //this.markAsUnread();
        } else {
          this.noUserYet = true;
        }
      } else {
        const tutorIndex = users.findIndex(u => u.id === this.assignedTutorId);
        if (tutorIndex > -1) {
          this.friendUser = users.splice(tutorIndex, 1)[0];
          //this.markAsUnread();
        } else {
          // If Tutor is not in the list, create a placeholder for them
          this.friendUser = {id: this.assignedTutorId, friendName: this.assignedTutorName, role: ROLE_ADMIN};
        }

        this.userList = [this.friendUser];
      }
    });
  }

  // markAsUnread() {
  //   this.firestoreService.getUnreadMessages(this.loggedUser.id).subscribe((count: number | undefined) => {
  //     const unreadMssg = count ? count : 0; // Este valor me servirá para mostrar la cantidad total de mensajes
  //     if (unreadMssg > 0) {
  //       this.firestoreService.getFriendsWithUnreadMessages(this.loggedUser.id).subscribe(friendsWithUnread => {
  //         this.userList.forEach(user => {
  //           if (friendsWithUnread.includes(user.id)) {
  //             user.hasUnreadMessages = true;
  //             this._showNewChatNotif = true;
  //           }
  //         });
  //       });
  //     }
  //   });
  // }

  async showMessages(friend: any) {
    this.friendUser = friend;
    if (!friend.chatId) {
      // Start a new conversation with Tutor
      this.currentChatId = await this.firestoreService.createNewConversation(this.friendUser, this.loggedUser);
      this.messages = [];
    } else {
      this.currentChatId = friend.chatId;
      this.subscribeToMessages(friend);
    }
  }

  subscribeToMessages(friend) {
    this.firestoreService.getMessages(friend).subscribe(async messages => {
      if (messages) {
        this.hasMessages = true;
        this.messages = messages.reverse();
      }
    });
  }

  sendMessage() {
    if (this.newMessage.trim() === '') return;
    const message = {
      text: this.newMessage,
      timestamp: new Date(),
      senderId: this.loggedUser.id,
      receiverId: this.friendUser.id
    };

    this.firestoreService.sendMessage(this.friendUser, message).then(() => {
      this.newMessage = '';

      // If this is the first message in the chat, we need to initial the subscription
      if (!this.hasMessages) this.subscribeToMessages(this.friendUser);
    });
  }

  formatMessageTimestamp(firestoreTimestamp: any): string {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const messageDate = new firebase.firestore.Timestamp(firestoreTimestamp.seconds, firestoreTimestamp.nanoseconds).toDate();
    const messageIsToday = messageDate >= today;
    const messageIsThisYear = messageDate.getFullYear() === now.getFullYear();

    let formatString = 'HH:mm';
    if (!messageIsToday) {
      formatString = 'dd/MM HH:mm';
    }
    if (!messageIsThisYear) {
      formatString = 'dd/MM/yyyy HH:mm';
    }

    return formatDate(messageDate, formatString, this.locale);
  }
}
